var _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icon-css-tw",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "tw-a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h640v480H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tw-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M0 0h720v480H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000095",
    d: "M0 0h360v240H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154 126.9l-2.5 9.6 9.4 2.6-1.8-7.1zM200.9 132l-1.8 7.1 9.4-2.6-2.5-9.6zM159.1 108l-5.1 5.1 1.9 6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.9 120l-1.9 6.9 5.1 5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 113.1l-6.9 6.9 6.9 6.9 1.9-6.9zM168 140.9l5.1 5.1 6.9-1.9zM186.9 146l9.6 2.5 2.6-9.4-7.1 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 140.9l7.1-1.8 1.8-7.1zM160.9 139.1l2.6 9.4 9.6-2.5-5.1-5.1zM180 144.1l6.9 1.9 5.1-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.1 146l6.9 6.9 6.9-6.9-6.9-1.9zM160.9 100.9l-9.4 2.6 2.5 9.6 5.1-5.1zM159.1 132l1.8 7.1 7.1 1.8zM204.1 120l1.9-6.9-5.1-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 99.1l-7.1 1.8-1.8 7.1zM200.9 108l-1.8-7.1-7.1-1.8zM206 126.9l6.9-6.9-6.9-6.9-1.9 6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.9 108l-8.9-8.9-12-3.2-12 3.2-8.9 8.9-3.2 12 3.2 12 8.9 8.9 12 3.2 12-3.2 8.9-8.9 3.2-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.9 132l5.1-5.1-1.9-6.9zM206 113.1l2.5-9.6-9.4-2.6 1.8 7.1zM199.1 100.9l-2.6-9.4-9.6 2.5 5.1 5.1zM173.1 94l-9.6-2.5-2.6 9.4 7.1-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 95.9l-6.9-1.9-5.1 5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.9 94l-6.9-6.9-6.9 6.9 6.9 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 99.1l-5.1-5.1-6.9 1.9zM173.1 146l-9.6 2.5 4.5 16.6 12-12.2zM168 165.1l12 44.9 12-44.9-12-12.2zM160.9 139.1l-9.4-2.6-4.4 16.4 16.4-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.1 152.9l-12 45.1 32.9-32.9-4.5-16.6zM135.1 132L102 165.1l45.1-12.2 4.4-16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154 126.9l-6.9-6.9-12 12 16.4 4.5zM154 113.1l-2.5-9.6-16.4 4.5 12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.1 108L90 120l45.1 12 12-12zM225.1 132l-16.6 4.5 4.4 16.4 45.1 12.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.1 139.1l-2.6 9.4 16.4 4.4-4.4-16.4zM186.9 146l-6.9 6.9 12 12.2 4.5-16.6zM206 126.9l2.5 9.6 16.6-4.5-12.2-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 165.1l33.1 32.9-12.2-45.1-16.4-4.4zM199.1 100.9l9.4 2.6 4.4-16.4-16.4 4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.1 108L258 75.1l-45.1 12-4.4 16.4zM212.9 87.1L225.1 42 192 75.1l4.5 16.4zM225.1 132l44.9-12-44.9-12-12.2 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206 113.1l6.9 6.9 12.2-12-16.6-4.5zM168 75.1L135.1 42l12 45.1 16.4 4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.9 100.9l2.6-9.4-16.4-4.4 4.4 16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.1 87.1l-45.1-12 33.1 32.9 16.4-4.5zM186.9 94l9.6-2.5-4.5-16.4-12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 75.1L180 30l-12 45.1 12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.1 94l6.9-6.9-12-12-4.5 16.4z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 120,
    r: 51.1,
    fill: "#000095"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 120,
    r: 45.1,
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/tw.54d619ea3985fafba58febe972ac2ada.svg";
export { ForwardRef as ReactComponent };